
class PageNewsletter {
  constructor() {
    this._init();
  }


  _init() {
    const checkAllBox = document.querySelector<HTMLInputElement>('.newsletter input[name="all"]');
    const listCheckboxes = document.querySelectorAll<HTMLInputElement>('.newsletter__list input[name="listIDs[]"]');

    if (checkAllBox) {
      checkAllBox.addEventListener('change', () => {
        listCheckboxes.forEach((checkbox) => {
          checkbox.checked = checkAllBox.checked;
        });
      });
    }
  }
}

export const pageNewsletter = new PageNewsletter();
